import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Input, OnInit, EventEmitter, OnChanges, ViewChild, Optional } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import { CommonSerivce } from '../common.service';
import { UserService } from '../user.service';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as _ from 'underscore';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';


import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDialogApprovalAction, IReturnDialogApprovalAction } from '../../models/shared.services.interface';
import { HostListener } from "@angular/core";


@Component({
  selector: 'approvalAction',
  styleUrls: ['../../share.component.css'
  ],
  providers: [CommonSerivce, UserService, DatePipe],
  templateUrl: './bcpApprovalAction.component.html'
})



export class bcpApprovalActionComponent implements OnInit {

  /*
      RecordList - Search result list
      SelectedRecordList - User selected record (Multiple) in the result table
      SelectedRecord - User selected record (Single) for edition
  */
  public RecordList: IApprovalAction[];
  public SelectedRecordList: IApprovalAction[];
  public SelectedRecord: IApprovalAction;
  public InputErrorMsg: string[];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder;
  public cols: any;
  public exportColumns: any;
  public pdfColumns = [];
  public attachmentCols: any;



  //  Code value list for List Box, add required code value list
  public zeroListValue: IDropdownList = { value: "0", label: ' Not Set', desc02: ' ' };
  public ActiveFlagList: IDropdownList[];
  public ApproverList: IApproverList[];
  public ApproverListDropdown: IDropdownList[];
  public ActionCodeList: IDropdownList[];

  /*
      sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
      softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = '';

  public globalFilterValue1: string = "";

  /*
      Major control variables
          FormTitle - Initial Form Title for the landing form
          PrimaryApiPath - Path for the API controller per component 
          ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
          AutoReload - control auto reload component
          
  */
  FormTitle: String = "Approval Action";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/BcpApprovalRoute/";
  ListApiPath: string = "api/BcpListValue/ByListCode/";
  SecurityApiPath: string = "api/BcpUserSecurityAction/";
  SendEmailPath: string = "api/BcpEmailService/";
  DropdownListApiPath: string = "api/BcpListValue/DropdownListByListCode/";
  UdcApiPath: string = "api/WosUdcList/ByUdc/";
  DropdownUdcApiPath: string = "api/WosUdcList/DropdownListByUdc/";

  ShowAddForm: Boolean = false;
  ShowEditForm: Boolean = false;
  SuccessUpload: Boolean = false;
  AddMode: string = "N";
  processingFlag: string = "N";

  AutoReload: Boolean = true;

  scrollHeight: string = "";
  scrollWidth: string = "";

  httpOriginalUrl: String;
  stringifyValue = "";
  stringifyUploadValue = "";
  Headers = new HttpHeaders();
  isLoggedIn: boolean = false;

  //Attachment related
  public uploadAttachment: boolean = false;
  public record: any;
  uploadFile: File;

  phoneLink: string;
  searchRowCount: number = 1;

  public emailNextApprover: boolean = false;
  public approveProcessEmail: IApproveProcessEmail;

  //dialog related variables
  dialogInput: IDialogApprovalAction;
  dialogOutput: IReturnDialogApprovalAction;
  screenHeight: number;
  screenWidth: number;
  rowCount: number;


  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
    , private bcp: CommonSerivce, private datePipe: DatePipe
    , private activRoute: ActivatedRoute, private router: Router
    , private dialogRef: MatDialogRef<bcpApprovalActionComponent>
    , private messageService: MessageService
    , @Optional() @Inject(MAT_DIALOG_DATA) public data: IDialogApprovalAction
  ) {

    this.dialogInput = data;
    this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    this.ListApiPath = originUrl + this.ListApiPath;
    this.SecurityApiPath = originUrl + this.SecurityApiPath;
    this.SendEmailPath = originUrl + this.SendEmailPath;
    this.DropdownListApiPath = originUrl + this.DropdownListApiPath;
    this.FormAccessRight = this.bcp.getAccessRightByProcess('APPROVAL_ROUTE');
    this.isLoggedIn = this.bcp.getLoginStatus();



    this.resetSearchField();
    this.getSecurity();
    this.getListValue();

    this.FormTitle = "Approval Action";
    this.ShowAddForm = true;
    this.ShowEditForm = false;

    this.scrollHeight = this.bcp.getDataTableHeight(4);
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.SelectedRecord = null;
    this.InputErrorMsg = [];

    const promises = [];
    promises.push(new Promise(async (resolve) => {
      await this.getListValue();
      resolve(true);
    }));

    Promise.all(promises)
      .then((results) => {
        this.resetSearchField();
        this.findRecord();
      }).catch((e) => {
        // Handle errors here
        console.log("Action Code not Found");
      });


    this.cols = [
      //{ field: 'id', header: 'id', width: '20', size: '1' },
      { field: 'approveLevel', header: 'Level', width: '25', size: '1' },
      { field: 'approveUser', header: 'Approver', width: '50', size: '1' },
      { field: 'approvalStatus', header: 'Status', width: '40', size: '1' },
      { field: 'submissionDate', header: 'Request Date', width: '60', size: '1' },
      { field: 'actionDate', header: 'Action Date', width: '60', size: '1' },
      { field: 'remark', header: 'Remark', width: '100', size: '1' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    this.pdfColumns[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);

    this.getScreenSize();



  }

  ngOnInit() {
    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.rowCount = 4;
    this.screenHeight = window.innerHeight - 0;
    this.screenWidth = window.innerWidth - 0;
    //console.log(this.screenHeight, this.screenWidth);
    if (this.screenHeight >= 600) {
      this.rowCount = Math.round((this.screenHeight - 450) / 40);
      this.rowCount = this.rowCount > 9 ? 9 : this.rowCount;
      //console.log(this.rowCount);
    }
  }

  selectRecord(recordId) {
    this.SelectedRecord = this.RecordList.find(i => i.id === recordId);
    this.closeForm();
  }

  closeForm() {

    this.dialogOutput = null;
    this.dialogOutput = JSON.parse('{"id": 0}');
    this.dialogOutput.approveAction = this.SearchFieldHolder["currentApproveAction"];
    this.dialogOutput.finalApprover = false;
    console.log(this.SearchFieldHolder);
    if (this.SearchFieldHolder["currentApproveAction"] == "REJECT"
      || (this.SearchFieldHolder["currentApproveAction"] == "APPROVE" 
      && (this.SearchFieldHolder["nextApprover"] == "NO NEXT APPROVER"
      || this.SearchFieldHolder["nextApprover"] == "0" ) )) {
      this.dialogOutput.finalApprover = true;
    }

    this.dialogRef.close(this.dialogOutput);
  }

  async getSecurity() {
    //check for email required for submitting response
    let checkResult6 = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/TDE5", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult6.applyEmail == "Y") {
      this.emailNextApprover = true;
    }
  }

  //to get required code list from Web API
  async getListValue() {
    //get list value  Box

    this.ActiveFlagList = await this.http.get(this.DropdownListApiPath + this.bcp.getCurrentDomainId() + "/ACTIVE_FLAG", this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.ActionCodeList = await this.http.get(this.PrimaryApiPath + "getActionCodeList/" + "TSML", this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    await this.getApproverList();
  }

  async getApproverList() {
    this.ApproverList = await this.http.get(this.PrimaryApiPath + "getApproverList/" + this.bcp.getCurrentDomainId() + "/" +  "BCP" + "/" + this.dialogInput.businessUnit, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.setApproverList();
  }

  setApproverList() {
    var tmp: IDropdownList = { value: "0", label: ' Not Use', desc02: '0' };
    this.ApproverListDropdown = [];

    this.ApproverList.forEach((e) => {
      tmp = { value: "0", label: ' Not Use', desc02: '' };
      tmp.value = e.loginId;
      tmp.label = e.fullName;
      tmp.desc02 = e.fullName;
      this.ApproverListDropdown.push(tmp);
    });

    tmp = { value: "0", label: ' Please Select Approver', desc02: '' };
    this.ApproverListDropdown.push(tmp);
    this.ApproverListDropdown = this.bcp.sortListByValue(this.ApproverListDropdown);
  }

  changeApprover(recordId, approveUser) {
    var clearApprover = false;
    this.RecordList.forEach((e) => {
      if (clearApprover) {
        e.approveUser = "0";
      }
      if (e.approveUser == "0") {
        clearApprover = true;
      }
      this.refreshApproverName(e.id, e.approveUser);
    });

  }

  refreshApproverName(recordId, approveUser) {
    let index1 = this.RecordList.findIndex(e => e.id == recordId);
    let index2 = this.ApproverListDropdown.findIndex(e => e.value == approveUser);
    index2 = index2 == -1 ? 0 : index2;
    this.RecordList[index1].approverName = this.ApproverListDropdown[index2].label;
  }

  getData() {
    this.http.get(this.PrimaryApiPath, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
      });
  }


  //get record by id and assign to selected record
  getDataById(id) {
    this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
      .subscribe((data: any) => {
        this.SelectedRecord = data;
      });
  }


  //get record by id and assign to selected record
  getDataBySearchField() {
    //console.log(this.SearchFieldHolder);
    this.processingFlag = "Y";
    this.searchRowCount = 1;
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    //console.log(this.stringifyValue);
    //console.log(this.stringifyValue);
    this.http.post(this.PrimaryApiPath + "getApprovalRecordList", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        this.searchRowCount = this.RecordList.length;
        this.SearchFieldHolder["disableSave"] = "Y";
        this.SearchFieldHolder["currentApprover"] = "";
        this.SearchFieldHolder["currentApproverName"] = "";
        this.SearchFieldHolder["nextApprover"] = "";
        this.SearchFieldHolder["finalApprover"] = "N";
        
        this.RecordList.forEach((e) => {
          if (e.actionDate == "1900-01-01T00:00:00") {
            e.actionDate = "";
          }
          this.refreshApproverName(e.id, e.approveUser);
          if (e.approveUser != "0" && e.approveUser != " ") {
            this.SearchFieldHolder["approverCount"] = this.SearchFieldHolder["approverCount"] + 1;
          }
          this.SearchFieldHolder["createUserName"] = e.createUserName;

          if ((e.approveAction == "" || e.approveAction == " ")
            && e.approvalSubmitted == "Y") {
            if (this.SearchFieldHolder["currentApprover"] == "") {
              this.SearchFieldHolder["currentApprover"] = e.approveUser;
              this.SearchFieldHolder["currentApproverName"] = e.approverName;
              this.SearchFieldHolder["currentApprovalRecordId"] = e.id;
            } else {
              if (this.SearchFieldHolder["nextApprover"] == "") {
                this.SearchFieldHolder["nextApprover"] = e.approveUser;
              }
            }
          }
        });
        if (this.SearchFieldHolder["currentApprover"] == this.bcp.getCurrentLoginUser()) {
          this.SearchFieldHolder["disableSave"] = "N";
        }
        if (this.SearchFieldHolder["nextApprover"] == "") {
          this.SearchFieldHolder["nextApprover"] = "NO NEXT APPROVER";
          this.SearchFieldHolder["finalApprover"] = "Y";
        }
        console.log(this.RecordList);
        this.processingFlag = "N";

      });
  }


  findRecord() {
    this.RecordList = null;
    this.SelectedRecord = null;
    this.SelectedRecordList = null;
    this.getDataBySearchField();
  }


  resetSearchField() {
    //dummy field, not use for searching
    this.SearchFieldHolder = JSON.parse('{"id": 0}');

    //set default value for all search fields
    //available field, please refer to the last part of [TableName]Controller.cs
    this.SearchFieldHolder["domainId"] = this.dialogInput.domainId;
    this.SearchFieldHolder["actionCode"] = this.dialogInput.actionCode;
    this.SearchFieldHolder["approveData"] = this.dialogInput.approveData;
    this.SearchFieldHolder["remark"] = "";
    //this.SearchFieldHolder["requestDate"] = this.dialogInput.requestDate;
    //this.SearchFieldHolder["routeCode"] = this.dialogInput.routeCode;
    //this.SearchFieldHolder["approveLevel"] = this.dialogInput.approveLevel;
    //this.SearchFieldHolder["createUser"] = this.bcp.getCurrentLoginUser();
    //this.SearchFieldHolder["createDate"] = this.bcp.getCurrentDateTime();

    if (this.ActionCodeList !== undefined && this.ActionCodeList !== null) {
      let index = this.ActionCodeList.findIndex(e => e.value == this.dialogInput.actionCode);
      this.SearchFieldHolder["actionCodeDesc"] = this.ActionCodeList[index].label;
    }
    
    this.SearchFieldHolder["approverCount"] = 0;
    this.SearchFieldHolder["currentApprover"] = "";
    this.SearchFieldHolder["nextApprover"] = "";
    this.SearchFieldHolder["finalApprover"] = "N";
    this.SearchFieldHolder["disableSave"] = "Y";

    this.SearchFieldHolder["currentApproveAction"] = "";
    this.SearchFieldHolder["currentApprovalRecordId"] = 0;
    this.searchRowCount = 1;
  }

  saveRecord(approveAction: string) {

    var inputOk = true;
    var submissionDate = this.bcp.getCurrentDateTime();

    if (this.bcp.getCurrentLoginUser() != this.SearchFieldHolder["currentApprover"] ) {
        inputOk = false;
        alert("You are not the current level approver.")
    }

    if (inputOk) {
      let index1 = this.RecordList.findIndex(e => e.id == this.SearchFieldHolder["currentApprovalRecordId"]);
      if (index1 == -1) {
        inputOk = false;
      }  
    }

    if (inputOk) {
      let index1 = this.RecordList.findIndex(e => e.id == this.SearchFieldHolder["currentApprovalRecordId"]);
      this.RecordList[index1].approveAction = approveAction.substr(0, 1);
      this.RecordList[index1].remark = this.SearchFieldHolder["remark"] == "" ? approveAction: this.SearchFieldHolder["remark"];
      this.RecordList[index1].actionDate = this.bcp.getCurrentDateTime();
      this.RecordList[index1].updateDate = this.bcp.getCurrentDateTime();
      this.RecordList[index1].updateUser = this.bcp.getCurrentLoginUser();
      console.log(this.RecordList[index1]);
      this.stringifyValue = JSON.stringify(this.RecordList[index1]);
      console.log(this.stringifyValue);
      console.log("approve date");
      this.http.put(this.PrimaryApiPath + "SubmitApproveRejectAction/" , this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            this.processingFlag = "N";
            this.SearchFieldHolder["currentApproveAction"] = approveAction;
            if (this.SearchFieldHolder["finalApprover"] != "Y" && this.SearchFieldHolder["currentApproveAction"] == "APPROVE"
              && this.SearchFieldHolder["nextApprover"] != "" && this.SearchFieldHolder["nextApprover"] != null && this.SearchFieldHolder["nextApprover"] != "0") {
              //send email to next approver
              if (this.emailNextApprover) {
                this.approveProcessEmail = {};
                this.approveProcessEmail.approveData = this.SearchFieldHolder["approveData"];
                this.approveProcessEmail.submissionDate = this.bcp.formatDateToDisplayString(submissionDate, true, false, "-", ":");
                this.approveProcessEmail.createUser = this.SearchFieldHolder["createUserName"];
                this.approveProcessEmail.approveUser = this.SearchFieldHolder["nextApprover"];
                this.sendNextApproverEmail();
              }
            }
            this.closeForm();
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
  }

  cancel() {
    this.findRecord();
    this.SelectedRecord = null;
    this.InputErrorMsg = [];

    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.FormTitle = "Approval Action";
  }





  // ========== ========== ========== ========== ========== 
  // Input processing
  // ========== ========== ========== ========== ========== 
  checkAllFieldEntered(inputObject, inputExcludeList) {
    const excludeList = ["id", "lineType", "inputDiscount", "inputSpecialDiscount", "inputType"]
      .map(v => v.toLowerCase());

    var count = 0;
    var inputOk: boolean;
    let tmpValue: string = "";
    var tmpByPassField: boolean;
    inputOk = true;
    let msg: string = "";

    Object.keys(inputObject).forEach(key => {

      count += 1;
      //console.log("Field " + count + "_" + (key.trim() + "                      ").slice(0, 20) + " _ " + inputObject[key] + "_");
      tmpValue = inputObject[key]
      tmpValue = (tmpValue + " ").trim();

      tmpByPassField = false;
      //field to bypass conditionally 

      if (excludeList.indexOf(key.trim().toLowerCase()) !== -1 || tmpByPassField) {
        //  if index not = -1, it is exist in exclude list and should be by pass for checking
        //console.log(key + " is exclude for checking");
      } else {
        //normalize the value
        if (tmpValue === "" || tmpValue === "null" || tmpValue === "0") {
          tmpValue === "0"
        } else {
          if (+tmpValue < 0) {
            tmpValue === "-1"
          }
        }

        if (tmpValue === "" || tmpValue === "null" || tmpValue === "0" || tmpValue === "-1") {
          //console.log(">>> " + key + " is invalid _" + tmpValue+"_");
          //set error message based on field name
          if (key == "inputQuantity" && this.SearchFieldHolder["customerGroup"] == "") {
            msg = msg + "|   " + "數量" + ".\n";
            inputOk = false;
            this.processingFlag = "N";
          }
          if (key == "inputUnitPrice") {
            msg = msg + "|   " + "單價" + ".\n";
            inputOk = false;
            this.processingFlag = "N";
          }
        }
      }
    });
    if (msg != "") {
      msg = "請輸入: " + "\n" + "---------- ---------- ---------- \n" + msg + "";
      msg = msg + "---------- ---------- ---------- ";
      alert(msg);
    }

    return inputOk;
  }

  specialValidation(inputObject) {
    const includeList = ["approveUser"]
      .map(v => v.toLowerCase());

    var count = 0;
    var inputOk: boolean;
    var tmpValue: string = "";
    var tmpByPassField: boolean;

    inputOk = true;
    let msg: string = "";

    let tmpApiString: string = "";

    Object.keys(inputObject).forEach(key => {
      count += 1;
      //console.log("Field " + count + "_" + (key.trim() + "                      ").slice(0, 20) + " _ " + inputObject[key] + "_");
      tmpValue = inputObject[key]
      tmpValue = (tmpValue + " ").trim();

      tmpByPassField = false;
      //field to bypass conditionally
      if (includeList.indexOf(key.trim().toLowerCase()) !== -1) {
        //  if index not = -1, it is exist in include list and required special validation
        //console.log(key + " is included for checking");
        if (tmpValue === "" || tmpValue === "null" || tmpValue === "0") {
          tmpValue === "0"
        } else {
          if (+tmpValue < 0) {
            tmpValue === "-1"
          }
        }


        // specialValidations
        var duplicateApproverCount = this.RecordList.filter(obj => obj.approveUser === tmpValue).length;
        //console.log("count is " + duplicateApproverCount);
        //console.log("temp is " + tmpValue);
        if (duplicateApproverCount > 1 && (tmpValue != "0" && tmpValue != " ")) {
          msg = msg + "|   " + "Duplicate Approver not Allowed - [" + tmpValue + "]" + ".\n";
          inputOk = false;
          this.processingFlag = "N";

        }

      }
      //console.log(inputObject[key] + "=== " + inputOk);
    });

    this.processingFlag = "N";
    if (msg != "") {
      msg = "Invalid Input: " + "\n" + "---------- ---------- ---------- \n" + msg + "";
      msg = msg + "---------- ---------- ---------- ";
      alert(msg);
      //this.messageService.add({
      //  severity: 'error',
      //  summary: 'Invalid Input'
      //  , detail: 'xxx'
      //});
    }
    return inputOk;
  }


  // ========== ========== ========== ========== ========== 
  // Grid table handling
  // ========== ========== ========== ========== ========== 
  clearGlobalFilter() {
    this.globalFilterValue1 = "";
    this.resetSearchField();
  }

  applyGlobalFilter() {
    var element = document.getElementById('globalFilter1');
    var event = new Event('input');

    element = document.getElementById('globalFilter1');
    element.dispatchEvent(event);
  }

  changeSort(event) {
    if (!event.order) {
      this.sortF = 'id';
    } else {
      this.sortF = event.field;
    }
  }

  onRowSelect(event) {
    //alert("selected " + event.data.id);
  }

  onRowUnselect(event) {
    //alert("remove " + event.data.id);
  }


  //-----------------------------------------------------------------------------
  //                      Email Functions
  //-----------------------------------------------------------------------------

  sendNextApproverEmail() {
    //this.approveProcessEmail = {};
    this.approveProcessEmail.inputDomain = this.bcp.getCurrentDomainId();
    this.approveProcessEmail.inputUser = this.bcp.getCurrentLoginUser();
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.approveProcessEmail);

    //this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendApprovalNextRequestEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        //this.emailReturnStatus = true;
        //this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          //this.emailReturnStatus = false;
          //this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }

}


interface IApprovalAction {
  id?;
  domainId?;
  requestDate?;
  submissionDate?;
  approvalSubmitted?;
  actionCode?;
  approveData?;
  routeCode?;
  approveLevel?;
  approveUser?;
  finalApprover?;
  approveAction?;
  actionDate?;
  remark?;
  delegationId?;
  originalApprover?;
  createUser?;
  createDate?;
  updateUser?;
  updateDate?;
  approverName?;
  createUserName?;
}

interface IDataRole {
}

interface IProcessRole {
}

interface IValueList {
}

interface IDropdownList {
  value?;
  label?; //this is desc01
  desc02?;
}

interface IApproverList {
  id?;
  domainId?;
  loginId?;
  fullName?;
}

interface IApproveProcessEmail {
  inputDomain?;
  inputUser?;
  approveData?;
  submissionDate?;
  createUser?;
  approveUser?;
}
